import { useState } from 'react';
import { showToast } from '@/lib/toast';

/**
 * Общий паттерн кнопок-переходов (Вход в Studio/Maintest 5i, Управление
 * лицензиями) — получить готовый URL по клику (ни один из трёх не требует
 * сессии в старом /admin, см. докблок ImpersonateUrlService в Laravel) и
 * открыть в новой вкладке.
 */
export function useOpenExternalUrl(fetchUrl: () => Promise<{ url: string }>, errorMessage: string) {
  const [loading, setLoading] = useState(false);
  const open = async () => {
    setLoading(true);
    try {
      const { url } = await fetchUrl();
      window.open(url, '_blank', 'noopener');
    } catch {
      showToast(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return { loading, open };
}
